module.exports = __webpack_public_path__ + "fonts/Manrope-500-latin12.02fde8a.woff2";